import {ComGroupIdentity} from '~shared/models';

type ComGroupIdentityTuple = [ComGroupIdentity['src'], ComGroupIdentity['id']];

export const makeComGroupIdentityKey = (identity: ComGroupIdentity) => {
    const identityTuple: ComGroupIdentityTuple = [identity.src, identity.id];

    return JSON.stringify(identityTuple);
};

export const parseComGroupIdentityKey = (identityTuple: string): ComGroupIdentity => {
    const [src, id] = JSON.parse(identityTuple) as ComGroupIdentityTuple;

    return {
        src,
        id,
    };
};
